import { useMutation } from "@tanstack/react-query";
import { rmPdHisInfApi, rmPdHistsApi } from "components/api/rm";
import { PAGE_ID_ROOM_HISTORY } from "components/constent";
import { apifield } from "components/utils/comm";
import { getDay, pageInitInf } from "components/utils/comm";
import { IPageNav } from "interface/index";
import { IRmPdHisInf } from "interface/rm/rmPdHis";
import i18n from "locales/i18n";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import useListRowInfStroe from "store/listRowInf";
import usePageNoStore from "store/pageNo";
import useUserStore from "store/user";
import { useProductHistoryParamsContext } from "./context";
import { initialPageNav } from "components/utils/comm";

// 객실 이력리스트 조회

export const useSearchList = () => {
  const { t } = useTranslation();
  const langCd = i18n.language;
  const { param } = useProductHistoryParamsContext();

  const [rowData, setRowData] = useState<any[] | null>(null);
  const pageNavRef = useRef<IPageNav>(initialPageNav);

  const mutation = useMutation({
    mutationKey: ["room-history-search"],
    mutationFn: rmPdHistsApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          //예약리스트 조회
          const pageNav = data.pageNav;
          pageNavRef.current = data.pageNav;
          const rmPdHistList = data.rmPdHistList.map(
            (hist: IRmPdHisInf, index: number) => {
              return {
                ...hist,
                No: (pageNav.pageNo - 1) * pageNav.pageRows + index + 1,
                day: getDay({ dayNm: hist?.dowV, langCd }) ?? "--",
                histStaTypNm:
                  hist.histStaTyp === "C"
                    ? t("txt_create")
                    : hist.histStaTyp === "U"
                    ? t("txt_update")
                    : hist.histStaTyp === "D"
                    ? t("txt_delete")
                    : "",
                sellYnNm:
                  hist.sellYn === "Y" ? t("status_sell_y") : t("status_sell_n"),
              };
            }
          );
          setRowData(rmPdHistList);
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  useEffect(() => {
    if (param) {
      mutation.mutate({
        ...param,
        ...pageInitInf,
      });
    }
  }, [param]);

  // NextPage
  const pageNo = usePageNoStore((state) => state.pageNo);
  const isCurrent = pageNo?.target === PAGE_ID_ROOM_HISTORY;

  useEffect(() => {
    if (isCurrent) {
      const params = {
        ...param,
        pageNo: pageNo?.no || 1,
        pageRows: pageNo?.pageRows,
      };

      mutation.mutate(params);
    }
  }, [pageNo?.no, pageNo?.pageRows]);

  return {
    rowData,
    pageNav: pageNavRef.current,
  };
};

// 객실 이력상세 조회
export const useGetData = () => {
  const user = useUserStore((state) => state.user);
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const rmPdHistDtlRef = useRef<IRmPdHisInf | null>(null);

  const params = {
    lodGrpNo: user?.manLodGrpNo ?? "",
    lodChlCd: "",
    rmPdHistNo: listRowInf.no,
  };

  const mutation = useMutation({
    mutationKey: ["room-history-detail"],
    mutationFn: rmPdHisInfApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          rmPdHistDtlRef.current = res.data.rmPdHistDtl;
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  useEffect(() => {
    if (params.rmPdHistNo) {
      mutation.mutate(params);
    }
  }, [params.rmPdHistNo]);

  return {
    rmPdHistDtl: rmPdHistDtlRef.current,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
};
